import {InitThumbnails, showThumbnails} from './thumbnails';

let articleIndex;
let articleIncrement;

export function InitImpressions() {
	const impressionContainer = document.querySelector('.bard__module.impressions > .card-container');
	if (impressionContainer === null) return;

	articleIndex = impressionContainer.getAttribute('data-start-count');
	articleIncrement = impressionContainer.getAttribute('data-step-count');
	articleIndex = articleIndex ? Number(articleIndex) : 6;
	articleIncrement = articleIncrement ? Number(articleIncrement) : 6;

	const impressions = impressionContainer.querySelectorAll('.impression');
	InitThumbnails(impressions, articleIndex);

	InitLoadMore(impressions);
}

function InitLoadMore(newsThumbnails) {
	const buttonLoadMore = document.querySelector('.bard__module.impressions .load-more-button');

	if (buttonLoadMore === null)
		return;

	if (articleIndex > newsThumbnails.length)
		buttonLoadMore.style.display = 'none';

	buttonLoadMore.addEventListener('click', () => {
		showThumbnails(newsThumbnails, articleIndex, articleIncrement);
		articleIndex += articleIncrement;

		if (articleIndex > newsThumbnails.length)
			buttonLoadMore.style.display = 'none';
	});
}
